import { defineCustomElements as setUpAtoms } from '@didomi/ui-atoms/loader';
import { setupComponents } from './components';

// DIRECTIVES
export * from './components';
// WE OVERRIDE THE MODAL COMPONENT TO PROVIDE A "PORTALIZED" VERSION
export { DidomiModalPortalized as DidomiModal } from './overlays/modalPortal';
export * from './formik-components/index';
const setUpDidomiUIAtoms = async (prefix?: string): Promise<void> => {
  setupComponents(prefix);
  await setUpAtoms(window, { transformTagName: (tagName: string) => `${prefix ? `${prefix}-` : ''}${tagName}` } as any);
};
export { setUpDidomiUIAtoms };
